import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image, ImageBackground, ImageSourcePropType, StyleSheet, Text, View } from 'react-native';

import { buyNowChips, ChipsBackgrOneLand } from '../../../../assets';
import { Package } from '../../../../store/types';
import { TouchableOpacity } from '../../common/Touchable';

type VipCardProps = {
	pkg: Package;
	pkgImg: ImageSourcePropType;
	chipImg: ImageSourcePropType;
	amount: number;
	price: number;
	onPayment: (packageItem: Package) => void; // parent decides web/native flow
};

const ChipCard = ({ pkg, pkgImg, chipImg, amount, price, onPayment }: VipCardProps) => {
	const { t } = useTranslation();
	const handleBuyPress = () => {
		// ✅ this will be handleBuyPress from BuyPackagesModal
		onPayment(pkg);
	};

	return (
		<ImageBackground source={ChipsBackgrOneLand} resizeMode='stretch' style={styles.background}>
			<View style={styles.card}>
				<View style={styles.packageContainer}>
					<Image source={pkgImg} style={styles.pkgImage} resizeMode='contain' />
				</View>

				<View style={styles.chipContainer}>
					<View style={styles.labelRow}>
						<Image source={chipImg} style={styles.chipImg} resizeMode='contain' />
						<Text style={styles.amount}>{amount}</Text>
					</View>

					<Text style={styles.price}>{price}€</Text>

					<TouchableOpacity style={styles.buyNowButtonContainer} onPress={handleBuyPress}>
						<ImageBackground source={buyNowChips} style={styles.buyNowImg} resizeMode='contain'>
							<Text style={styles.text}>{t('T_SITE_HEADER_BUY')}</Text>
						</ImageBackground>
					</TouchableOpacity>
				</View>
			</View>
		</ImageBackground>
	);
};

export default ChipCard;

const styles = StyleSheet.create({
	background: {
		width: '100%',
		textAlign: 'center',
		margin: 'auto',
	},
	card: {
		flexDirection: 'row',
		alignItems: 'center',
	},
	packageContainer: {
		flex: 1,
		alignItems: 'center',
	},
	chipContainer: {
		flex: 1,
		justifyContent: 'center',
		alignItems: 'center',
	},
	labelRow: {
		flexDirection: 'row',
		alignItems: 'center',
		marginTop: 8,
	},
	pkgImage: {
		width: 200,
		height: 160,
	},
	chipImg: {
		width: 30,
		height: 24,
	},
	amount: {
		fontSize: 20,
		fontWeight: '900',
		color: '#FFD700',
		textShadowColor: '#000',
		textShadowOffset: { width: 1, height: 2 },
		textShadowRadius: 2,
		letterSpacing: 0.5,
	},
	price: {
		fontSize: 20,
		fontWeight: '500',
		color: '#fff',
		textAlign: 'center',
		marginVertical: 12,
		textShadowColor: '#000',
		textShadowOffset: { width: 1, height: 1 },
		textShadowRadius: 2,
		letterSpacing: 1,
		textTransform: 'uppercase',
	},
	buyNowButtonContainer: {
		borderRadius: 6,
		paddingBottom: 10,
	},
	buyNowImg: {
		width: 110,
		height: 36,
	},
	text: {
		fontSize: 15,
		fontWeight: '700',
		letterSpacing: 0.6,
		color: '#E0E0E0',
		textShadowColor: 'rgba(0, 0, 0, 0.6)',
		textShadowOffset: { width: 0, height: 2 },
		textShadowRadius: 2,
		textTransform: 'uppercase',
		textAlign: 'center',
		paddingTop: 6,
	},
});
